/**
 * JobsList - Lista de vagas de emprego disponíveis
 * 
 * Extraído do App.js durante refatoração Fase 1
 * 
 * Funcionalidades:
 * - Fetch automático de vagas
 * - Renderização de JobCards
 * - Mensagem de lista vazia
 * 
 * Dependências:
 * - useTranslation (traduções)
 * - axios (requisições API)
 * - JobCard (componente extraído)
 */

import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "../translations";
import JobCard from "./JobCard";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const JobsList = () => {
  const [jobs, setJobs] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    try {
      const response = await axios.get(`${API}/jobs`);
      setJobs(response.data);
    } catch (error) {
      console.error("Error fetching jobs:", error);
    }
  };

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold">{t('availableJobs')}</h2>
      <div className="grid gap-4">
        {jobs.map((job) => (
          <JobCard key={job.id} job={job} />
        ))}
        {jobs.length === 0 && (
          <p className="text-gray-500 text-center py-8">{t('noJobsAvailable')}</p>
        )}
      </div>
    </div>
  );
};

export default JobsList;
